export function removeAllChildNodes(parent, removeSelf) {
  while (parent.firstChild) {
    removeAllChildNodes(parent.firstChild, true);
  }
  if (removeSelf) parent.remove();
}
